import { headerBgColor } from './HeaderBgStore.js';

export const updateHeaderBgColor = (value) => headerBgColor.update(oldValue => value);
